import { jsx as _jsx } from "react/jsx-runtime";
import isFinite from "lodash/isFinite";
import { memo, useCallback, useMemo } from "react";
import { SelectChipOptionContainer } from "~/components/Select/components/SelectChipOptionContainer";
import { Select } from "~/components/Select/Select";
const rateToOption = (rate)=>{
    const rateNumber = Number(rate) / 1000;
    return {
        value: rate,
        // Number.parseFloat is used to remove trailing zeros
        label: isFinite(rateNumber) ? "".concat(Number.parseFloat(rateNumber.toFixed(3)), "kHz") : rate
    };
};
export const AudioSampleRatesSelect = /*#__PURE__*/ memo((param)=>{
    let { audioRates, selectedValues, onSelectionChange, ...props } = param;
    const options = useMemo(()=>audioRates.map((rate)=>rateToOption(rate)), [
        audioRates
    ]);
    const selectedOptions = useMemo(()=>selectedValues.map((rate)=>rateToOption(rate)), [
        selectedValues
    ]);
    const onValuesChange = useCallback((param)=>{
        let { chips } = param;
        onSelectionChange(chips.map((chip)=>chip.value));
    }, [
        onSelectionChange
    ]);
    const listItemRenderer = useCallback((option)=>/*#__PURE__*/ _jsx(SelectChipOptionContainer, {
            className: "flex justify-between py-2",
            children: /*#__PURE__*/ _jsx("p", {
                className: "text-14 text-grey-12",
                children: option.label
            })
        }), []);
    return /*#__PURE__*/ _jsx(Select, {
        "data-testid": "AUDIO_SAMPLE_RATE",
        placeholder: "Search for audio sample rate i.e. 44kHz",
        listItemRenderer: listItemRenderer,
        maxDropdownHeight: 300,
        options: options,
        renderAsInput: true,
        onSelectionChange: onValuesChange,
        selectedOptions: selectedOptions,
        alwaysShowClearItemButton: true,
        isClearable: true,
        isSearchable: true,
        isSticky: true,
        size: "large",
        ...props
    });
});
AudioSampleRatesSelect.displayName = "AudioSampleRatesSelect";
